import React from 'react';
import PropTypes from 'prop-types';
import moment from 'moment';
import { parseFullName } from 'utils/helpers';
import { texts } from 'utils/languages/fr';
import { Typography } from '@mui/material';

const textSx = theme => ({
    marginLeft: '20px',
    fontSize: '15px',
    fontStyle: 'italic',
    lineHeight: 1.6,
    [theme.breakpoints.down(720)]: {
        margin: 0,
    },
});

const ValidationText = ({ validatedBy, validatedAt, invalidated, customText, sx }) => {
    if (customText) {
        return <Typography sx={textSx}>{customText}</Typography>;
    }
    return (
        <Typography
            sx={theme => ({ ...textSx(theme), ...(typeof sx === 'function' ? sx(theme) : sx) })}
        >
            {invalidated
                ? texts.INVALIDATED_BY(
                      parseFullName(validatedBy),
                      moment(validatedAt).format('DD/MM/YYYY')
                  )
                : texts.VALIDATED_BY(
                      parseFullName(validatedBy),
                      moment(validatedAt).format('DD/MM/YYYY')
                  )}
        </Typography>
    );
};

ValidationText.propTypes = {
    validatedBy: PropTypes.object.isRequired,
    validatedAt: PropTypes.string.isRequired,
    invalidated: PropTypes.bool,
    customText: PropTypes.string,
    sx: PropTypes.oneOfType([PropTypes.object, PropTypes.func]),
};

export default ValidationText;
